module.exports = __webpack_public_path__ + "overview-d35a4493/bookmark-c98c34d9b1d2ede4441a7c57b7958c54.svg";